<div class="contain" appDnd (fileDropped)="onFileDropped($event)">
  <input
    type="file"
    #fileDropRef
    id="fileDropRef"
    multiple
    (change)="fileBrowseHandler($event.target.files)"
  />
  <i
    class="fa fa-cloud-upload fa-5x"
    style="margin-bottom: 10px"
    aria-hidden="true"
  ></i>
  <h3 style="margin-bottom: 10px">
    Glissez vos documents ici ou parcourez vos fichiers
  </h3>
  @if (error === null) {
    <div>
      <p style="color: #768ca0; margin-bottom: 10px">
        Une fois importés, vos fichiers sont sécurisés
      </p>
    </div>
  } @else {
    <div class="alert alert-danger" role="alert">
      {{ error }}
    </div>
  }
  <pr-button size="xl" display="neutral" for="fileDropRef"
    >Ajouter un nouveau document</pr-button
  >
  @if (gedDocuments?.length) {
    <pr-button
      class="ged-choice"
      size="xl"
      display="neutral"
      variant="outline"
      icon="folder_open"
      label="Choisir un document de la GED"
      (onClick)="openGedPicker()"
    ></pr-button>
  }
</div>

@if (gedDocuments?.length) {
  <ged-picker
    #gedPickerRef
    [accountId]="gedAccountId"
    [documents]="gedDocuments"
    [ownerId]="gedOwnerId"
    (select)="gedDocumentSelected.emit($event)"
  ></ged-picker>
}

@if (files.length > 0 && form === true) {
  <div style="margin-top: 20px">
    <pr-table
      [tableData]="table"
      [swiperMinWidth]="992"
      class="mbl"
      [actionsTemplate]="exampleActionsTemplate"
    >
      <!-- Actions template -->
      <ng-template #exampleActionsTemplate let-document>
        <pr-toolbar clazz="horizontal">
          <pr-button
            display="danger"
            clazz="pr-toolbar-button last"
            (click)="deleteDocument(document)"
            icon="delete_outline"
          ></pr-button>
        </pr-toolbar>
      </ng-template>
      <!-- Empty Template -->
      <h1 class="text-center" emptyTemplate>
        Vous n'avez pas encore de document
      </h1>
    </pr-table>
  </div>
}
